import { AssetWallet } from "@models/interfaces";
import { TYPE_NAME_CRYPTO } from "@helpers/constants";

export class CryptoWallet extends AssetWallet {
	public static TypeName = TYPE_NAME_CRYPTO;
}
